/**
 * The bar scale (spec 234 US7): every horizontal bar on the AI usage tabs, and the
 * shared composition bar, draws from these. They had drifted to 4, 10 and 12 px,
 * three track greys and two stacked-bar implementations.
 *
 * Two heights — a bar that stands on its own (a meter, a stacked share) and a bar
 * inside a table row, thin so it never outweighs the figure it sits under — and one
 * track, the part of a meter not yet filled. `muted-foreground/15` rather than
 * `bg-muted`: on a card, `muted` is two steps from white and the track vanished, and
 * a meter's track *is* its limit.
 */
export const BAR_HEIGHT = 'h-2.5';

export const BAR_HEIGHT_INLINE = 'h-1';

export const BAR_TRACK = 'bg-muted-foreground/15';
